import { Link } from "react-router-dom";
import Iconify from "../../../ui/iconify/Iconify";
import PropTypes from "prop-types";

const RenderEditGridAction = ({ rowData, col, rowIndex, allowEditGrid, onRowEditSave, isRowEditable, onRowEditCancel, editGridSettings, onRowDataDelete }) => {

    const isEditingRow = allowEditGrid && isRowEditable;

    const handleDelete = (rowIndex) => {
        if (onRowDataDelete) {
            onRowDataDelete(rowIndex);
        }
    }

    const handleRowEditSave = (rowIndex, rowData) => {
        if (onRowEditSave) {
            onRowEditSave(rowIndex);
        }
    }

    const handleEditCancel = (rowIndex) => {
        if (onRowEditCancel) {
            onRowEditCancel(rowIndex);
        }
    }

    return (
        <div className="d-flex action-button">
            {isEditingRow && onRowEditSave && editGridSettings?.buttons?.save && (
                <Link
                    onClick={(e) => {
                        e.preventDefault();
                        handleRowEditSave(rowIndex, rowData);
                    }}
                    className="mr-4"
                    title="SAVE"
                >
                    <Iconify icon={"subway:tick"} altText={"Save Icon"} style={{ color: '#4be500' }} />
                </Link>
            )}

            {/* Cancel Button */}
            {isEditingRow && onRowEditCancel && editGridSettings?.buttons?.cancel && (
                <Link
                    onClick={(e) => {
                        e.preventDefault();
                        handleEditCancel(rowIndex);
                    }}
                    className="mr-4"
                    title="CANCEL"
                >
                    {/* <Image imagePath={AppIcons.CancelIcon} altText="Cancel Icon" /> */}
                    <Iconify icon={"mdi:clear-bold"} altText={"Save Icon"} style={{ color: '#ff1818' }} />
                </Link>
            )}

            {isEditingRow && editGridSettings?.buttons?.delete && (
                <Link
                    onClick={(e) => {
                        e.preventDefault();
                        handleDelete(rowIndex);
                    }}
                    className="mr-4"
                    title="DELETE"
                >
                    <Iconify icon={"ic:round-delete"} altText={"Delete"} />
                </Link>
            )}
        </div>
    );
};

RenderEditGridAction.propTypes = {
    rowData: PropTypes.object.isRequired,
    col: PropTypes.object,
    rowIndex: PropTypes.number.isRequired,
    allowEditGrid: PropTypes.bool,
    onRowEditSave: PropTypes.func,
    isRowEditable: PropTypes.bool,
    onRowEditCancel: PropTypes.func,
    editGridSettings: PropTypes.shape({
        buttons: PropTypes.shape({
            save: PropTypes.bool,
            cancel: PropTypes.bool,
            delete: PropTypes.bool,
        }),
    }),
    onRowDataDelete: PropTypes.func,
};

export default RenderEditGridAction